import { memo } from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Skeleton from '@mui/material/Skeleton';

const BaseDrawerSkeleton = () => {
  return (
    <>
      <Card sx={{ m: 2, background: '#F1F2F5' }}>
        <CardHeader
          subheader={<Skeleton animation="wave" height={10} width="40%" />}
          title={
            <Skeleton
              animation="wave"
              height='100px'
              width="80%"
              style={{ marginBottom: '30px' }}
            />
          }
        />
      </Card> 
      <Card sx={{ m: 2, background: '#F1F2F5' }}>
        <CardHeader
          subheader={<Skeleton animation="wave" height={10} width="40%" />}
          title={
            <Skeleton
              animation="wave"
              height='100px'
              width="80%"
              style={{ marginBottom: '30px' }}
            />
          }
        />
      </Card> 
    </>
  )
};

export default memo(BaseDrawerSkeleton);